import DotGrid from './src/dot-grid-combined';
export default DotGrid;